var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6913 0H18.3087C21.452 0 24 2.54799 24 5.6913V18.3087C24 21.452 21.452 24 18.3087 24H5.6913C2.54799 24 0 21.452 0 18.3087V5.6913C0 2.54799 2.54848 0 5.6913 0Z",
    fill: "#121D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0229 5.7522H7.00456C5.20272 5.7522 3.74219 7.21273 3.74219 9.01457V14.8929C3.74219 16.6947 5.20272 18.1553 7.00456 18.1553H17.0229C18.8247 18.1553 20.2853 16.6947 20.2853 14.8929V9.01457C20.2848 7.21273 18.8242 5.7522 17.0229 5.7522Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57812 14.6739V9.23359C9.57812 8.80347 10.0469 8.53756 10.416 8.75833L14.9623 11.4785C15.3215 11.6933 15.3215 12.2137 14.9623 12.4285L10.416 15.1486C10.0469 15.3694 9.57812 15.1035 9.57812 14.6739Z",
    fill: "#121D39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeContact);
export default __webpack_public_path__ + "static/media/youtube-contact.13f9910ca38fbc17f01e38d2fcdd6e39.svg";
export { ForwardRef as ReactComponent };